export default __webpack_public_path__ + "static/media/012-line-pink.7abea7e4.svg";